/* unplugin-vue-components disabled */import { render } from "./xinjiangstandardappmap.vue?vue&type=template&id=75d4760a&scoped=true"
import script from "./xinjiangstandardappmap.vue?vue&type=script&lang=js"
export * from "./xinjiangstandardappmap.vue?vue&type=script&lang=js"

import "./xinjiangstandardappmap.vue?vue&type=style&index=0&id=75d4760a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d4760a"]])

export default __exports__